export default __webpack_public_path__ + "static/grenette-bold-pro-93b3440a929c9c5647e61a48ad2ea45f.ttf";